import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token: null,
  },
  reducers: {
    setToken(state, action) {
      state.token = action.payload;
    },
    // Other reducers if needed
  },
});

export const { setToken } = authSlice.actions;
export default authSlice.reducer;